import { IonButton } from "@ionic/react";
import React from "react";
import { LogOut } from "../../services/AuthServices";

interface Props {
  setShowModal1: Function;
}

const CancelLogoutModal: React.FC<Props> = ({ setShowModal1 }) => {
  async function clearAndRedirect() {
    await LogOut();
    // let getAssessmentHisotory = JSON.parse(
    //   localStorage.getItem("summaryDetail") || "[]"
    // );
    // localStorage.clear();
    // localStorage.setItem(
    //   "summaryDetail",
    //   JSON.stringify(getAssessmentHisotory!)
    // );

    setShowModal1(false);
    window.location.href = window.location.origin + "/login";
  }

  return (
    <div className="overall-center-modal">
      <div className="generic-modal-main-wrap">
        <div className="icon-sec text-center">
          {/* Exit SVG */}
          <svg
            width="103"
            height="103"
            viewBox="0 0 103 103"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M47.4783 30.4158C49.6994 28.1947 53.3006 28.1947 55.5217 30.4158L72.5842 47.4783C73.6508 48.5449 74.25 49.9916 74.25 51.5C74.25 53.0084 73.6508 54.4551 72.5842 55.5217L55.5217 72.5842C53.3006 74.8053 49.6994 74.8053 47.4783 72.5842C45.2572 70.3631 45.2572 66.7619 47.4783 64.5408L54.8317 57.1875H6C2.85888 57.1875 0.3125 54.6411 0.3125 51.5C0.3125 48.3589 2.85888 45.8125 6 45.8125L54.8317 45.8125L47.4783 38.4592C45.2572 36.2381 45.2572 32.6369 47.4783 30.4158Z"
              fill="#802392"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.3125 11.6875C0.3125 5.40526 5.40526 0.3125 11.6875 0.3125H91.3125C97.5947 0.3125 102.688 5.40526 102.688 11.6875V91.3125C102.688 97.5947 97.5947 102.688 91.3125 102.688H11.6875C5.40526 102.688 0.3125 97.5947 0.3125 91.3125V79.9375C0.3125 76.7964 2.85888 74.25 6 74.25C9.14112 74.25 11.6875 76.7964 11.6875 79.9375V91.3125H91.3125V11.6875H11.6875V23.0625C11.6875 26.2036 9.14112 28.75 6 28.75C2.85888 28.75 0.3125 26.2036 0.3125 23.0625V11.6875Z"
              fill="#802392"
            />
          </svg>
          {/* Exit SVG */}
        </div>

        <div className="generic-modal-text">
          <h1>Logout</h1>
          <p>Are you sure you want to logout?</p>
        </div>

        <div className="generic-modal-btn-wrap two-btns">
          <ul>
            <li>
              <IonButton
                className="generic-btn generic-btn-outline"
                placeholder={undefined}
                onClick={() => {
                  setShowModal1(false);
                }}
              >
                Cancel
              </IonButton>
            </li>

            <li>
              <IonButton
                className="generic-btn"
                onClick={clearAndRedirect}
                placeholder={undefined}
              >
                Logout
              </IonButton>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CancelLogoutModal;
